import routerPaths from "./routerPaths";

export default routerPaths